import { isNil, toNumber, isFinite } from 'lodash'

/**
 *
 * A helper function to compare two cell values for table sorting,
 * handling empty values, numeric values, * and string values with locale-aware
 * comparison.
 *
 * @name tableSortingCompareValues
 * @type Function
 * @param {String, Number} cellValueA - A value from the first cell being compared
 * @param {String, Number} cellValueB - A value from the second cell being compared
 * @param {String} direction - The sort direction, either 'asc' or 'desc'
 *
 */

function tableSortingCompareValues(cellValueA, cellValueB, direction) {
  const aEmpty = isNil(cellValueA) || cellValueA === ''
  const bEmpty = isNil(cellValueB) || cellValueB === ''
  if (aEmpty && bEmpty) return 0
  if (aEmpty) return direction === 'asc' ? 1 : -1
  if (bEmpty) return direction === 'asc' ? -1 : 1

  const aNum = toNumber(cellValueA)
  const bNum = toNumber(cellValueB)

  if (isFinite(aNum) && isFinite(bNum)) {
    return direction === 'asc' ? aNum - bNum : bNum - aNum
  }
  const cmp = String(cellValueA).localeCompare(String(cellValueB), undefined, {
    numeric: true,
  })
  return direction === 'asc' ? cmp : -cmp
}

export default tableSortingCompareValues
